import { lazy } from 'react';

export const PlayerAddStatusOverwriteForm = lazy(
  () => import('./PlayerAddStatusOverwriteForm'),
);
